import { type SVGProps } from "react";

export const MyTeeBoxIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        preserveAspectRatio="xMidYMid meet"
        width="20px" height="20px" viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>

        <circle fill="#366695" cx="256" cy="256" r="256" />
        <path fill="#273B7A" d="M502.153,326.539L320.412,144.796l-58.561,99.393l-91.184,26.033l90.131,90.131L256,446.009
	l59.116,59.116C405.18,483.835,476.855,414.982,502.153,326.539z"/>
        <path fill="#FFC61B" d="M341.333,270.222c0-7.854-38.205-14.222-85.333-14.222s-85.333,6.368-85.333,14.222
	c0,5.999,22.292,11.126,53.813,13.215c2.341,0.155,4.255,1.938,4.587,4.26l22.006,154.038c0.814,5.697,9.04,5.697,9.856,0
	l22.006-154.038c0.333-2.324,2.245-4.105,4.587-4.26C319.042,281.348,341.333,276.221,341.333,270.222z"/>
        <path fill="#EAA22F" d="M256,256v190.011c2.26,0,4.52-1.424,4.927-4.274l22.006-154.038c0.333-2.324,2.245-4.105,4.587-4.26
	c31.522-2.091,53.813-7.218,53.813-13.217C341.333,262.368,303.128,256,256,256z"/>
        <circle fill="#FFFFFF" cx="256" cy="193.939" r="81.024" />
        <g>
            <path fill="#D0D1D3" d="M337.024,193.939c0-44.747-36.276-81.024-81.024-81.024v162.047
		C300.747,274.963,337.024,238.687,337.024,193.939z"/>
            <circle fill="#D0D1D3" cx="207.076" cy="156.444" r="8.62" />
            <circle fill="#D0D1D3" cx="236.175" cy="190.492" r="8.62" />
            <circle fill="#D0D1D3" cx="236.175" cy="150.842" r="8.62" />
            <circle fill="#D0D1D3" cx="201.473" cy="190.492" r="8.62" />
        </g>
    </svg>

);
